import React from 'react';

const RiskScoreGauge = ({ score = 0 }) => {
  // Calculate angle for the needle (0-180 degrees)
  const angle = (score / 100) * 180 - 90;

  // Determine color based on score
  const getColor = (value) => {
    if (value <= 25) return '#10B981'; // Green
    if (value <= 50) return '#FCD34D'; // Yellow
    if (value <= 75) return '#F59E0B'; // Orange
    return '#DC2626'; // Red
  };

  const getRiskLevel = (value) => {
    if (value <= 25) return 'LOW RISK';
    if (value <= 50) return 'MEDIUM RISK';
    if (value <= 75) return 'HIGH RISK';
    return 'CRITICAL RISK';
  };

  return (
    <div className="flex flex-col items-center p-8">
      <svg width="300" height="200" viewBox="0 0 300 200">
        {/* Background Arc - Green Zone */}
        <path
          d="M 30 150 A 120 120 0 0 1 90 40"
          fill="none"
          stroke="#10B981"
          strokeWidth="30"
          strokeLinecap="round"
        />

        {/* Yellow Zone */}
        <path
          d="M 90 40 A 120 120 0 0 1 150 20"
          fill="none"
          stroke="#FCD34D"
          strokeWidth="30"
          strokeLinecap="round"
        />

        {/* Orange Zone */}
        <path
          d="M 150 20 A 120 120 0 0 1 210 40"
          fill="none"
          stroke="#F59E0B"
          strokeWidth="30"
          strokeLinecap="round"
        />

        {/* Red Zone */}
        <path
          d="M 210 40 A 120 120 0 0 1 270 150"
          fill="none"
          stroke="#DC2626"
          strokeWidth="30"
          strokeLinecap="round"
        />

        {/* Zone Labels */}
        <text x="40" y="180" fontSize="10" fill="#666">0</text>
        <text x="75" y="60" fontSize="10" fill="#666">25</text>
        <text x="145" y="30" fontSize="10" fill="#666">50</text>
        <text x="215" y="60" fontSize="10" fill="#666">75</text>
        <text x="255" y="180" fontSize="10" fill="#666">100</text>

        {/* Center Circle */}
        <circle cx="150" cy="150" r="10" fill="#333" />

        {/* Needle */}
        <line
          x1="150"
          y1="150"
          x2="150"
          y2="50"
          stroke={getColor(score)}
          strokeWidth="4"
          strokeLinecap="round"
          transform={`rotate(${angle} 150 150)`}
          style={{ transition: 'transform 1s ease-out' }}
        />

        {/* Needle Pointer */}
        <circle
          cx="150"
          cy="50"
          r="8"
          fill={getColor(score)}
          transform={`rotate(${angle} 150 150)`}
          style={{ transition: 'transform 1s ease-out' }}
        />
      </svg>

      {/* Score Display */}
      <div className="mt-4 text-center">
        <div
          className="text-6xl font-bold mb-2"
          style={{ color: getColor(score) }}
        >
          {score}/100
        </div>
        <div
          className="text-xl font-semibold px-4 py-2 rounded"
          style={{
            backgroundColor: getColor(score) + '20',
            color: getColor(score)
          }}
        >
          {getRiskLevel(score)}
        </div>
      </div>
    </div>
  );
};

export default RiskScoreGauge;

// Usage example:
// <RiskScoreGauge score={15} />  // Low risk
// <RiskScoreGauge score={35} />  // Medium risk
// <RiskScoreGauge score={65} />  // High risk
// <RiskScoreGauge score={85} />  // Critical risk
